/**
 ################################
 * Component geeg_burger_menu
 * Built with Maciste / Version 2.0
 ################################
 */


'use strict';

jQuery(document).ready(function ($) {
     $('#toggle').click(function () {
        $(this).toggleClass('active');
        $('#overlay').toggleClass('open');
        var body = document.body;
        body.classList.toggle('addd_no_scroll');
    });
});
